Util = require 'lib/util'

startDecayingInterval = (fn, options = {
  resetAfterMouseMove: true
  intervals: [
    {
      iterations: 6
      timeout: Util.getMs(seconds: 10)
    }
    {
      iterations: 10
      timeout: Util.getMs(minutes: 1)
    }
  ]
}) ->
  intervals = null
  idTimeout = null
  watchingMouse = false

  cancel = ->
    clearTimeout(idTimeout)
    if watchingMouse
      document.removeEventListener('mousemove', start)
      watchingMouse = false

  watchMouse = ->
    if options.resetAfterMouseMove && !watchingMouse
      document.addEventListener('mousemove', start)
      watchingMouse = true

  nextStep = ->
    if intervals.length
      nextInterval = intervals.shift()
      idTimeout = setTimeout ->
        fn()
        requestAnimationFrame(nextStep)
      , nextInterval
      if nextInterval > options.intervals[0].timeout
        watchMouse()
    else
      watchMouse()

  start = ->
    cancel()
    intervals = []
    for { iterations, timeout } in options.intervals
      for i in [0...iterations]
        intervals.push(timeout)
    nextStep()

  start()

  cancel

module.exports = startDecayingInterval



// WEBPACK FOOTER //
// ./app/scripts/lib/util/decaying-interval.coffee